export function rebaseApiPageUrl (url) {
  if (!url) return url
  if (url.indexOf('/pages/eas_pc/') === -1 && url.indexOf('pages/eas_pc/') !== 0) return url
  const originMatch = url.match(/^(https?:)?\/\/[^/]+/i)
  if (originMatch) {
    return window.location.origin + url.slice(originMatch[0].length)
  }
  if (url.charAt(0) === '/') {
    return window.location.origin + url
  }
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url
  return window.location.origin + '/' + url
}



// WEBPACK FOOTER //
// ./src/components/utils/apiPageJump.js